import React from 'react';
// import styled from 'styled-components';

// Templates
import { LayoutDefault } from '@templates';

// Components
import { Typography } from '@components';

const Terms = () => {
  return (
    <LayoutDefault>
      <Typography as="h1" weight="bold" size="3.2em">
        Termos e condições
      </Typography>
    </LayoutDefault>
  );
};

export default Terms;
export { Terms };
